// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"0bb264df","31":"c51e5642","70":"7e0c91dd","125":"176104ae","744":"1277bf4f"}[chunkId] + ".chunk.js";
};